import { useEffect } from "react";
import { X } from "lucide-react";
import "@/PhotoLightbox.css";
import { useLanguage } from "@/i18n";

export default function PhotoLightbox({ photo, onClose }) {
  const { language, t } = useLanguage();
  useEffect(() => {
    const closeOnEscape = (event) => { if (event.key === "Escape") onClose(); };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [onClose]);

  if (!photo) return null;
  const caption = photo.captions?.[language] || photo.title;
  return <div className="photo-lightbox" role="dialog" aria-modal="true" aria-label={caption || photo.alt} onClick={onClose} data-testid="photo-lightbox">
    <button className="lightbox-close" onClick={onClose} aria-label={t("common.close")} data-testid="photo-lightbox-close"><X size={21} /></button>
    <img src={photo.src} alt={photo.alt} data-testid="photo-lightbox-image" />
    {caption && <span className="lightbox-caption" data-testid="photo-lightbox-caption">{caption}</span>}
  </div>;
}